// Lupa de zoom para imágenes de producto (Craft)
document.addEventListener('DOMContentLoaded', () => {
  // Selectores típicos de Craft para imágenes del producto
  const imgSelectors = '.product__media img, .media img, product-media img, .product-gallery__media img';
  const productImgs = Array.from(document.querySelectorAll(imgSelectors))
    // nos quedamos con imágenes visibles y principales
    .filter(img => img.closest('section, product-media, .product') && img.width > 200);

  if (!productImgs.length) return;

  // Crea una sola lupa para toda la página
  const lens = document.createElement('div');
  lens.className = 'zoom-lens';
  document.body.appendChild(lens);

  const ZOOM = 2.2;        // nivel de aumento (ajústalo si quieres)
  const LENS = 160;        // tamaño de la lupa (debe coincidir con CSS)

  productImgs.forEach(img => {
    img.style.cursor = 'zoom-in';

    const enter = () => {
      const rect = img.getBoundingClientRect();
      lens.style.display = 'block';
      // Usa la imagen en alta resolución disponible
      lens.style.backgroundImage = `url('${img.currentSrc || img.src}')`;
      // Tamaño del fondo = tamaño mostrado x zoom
      lens.style.backgroundSize = `${rect.width * ZOOM}px ${rect.height * ZOOM}px`;
    };

    const move = (e) => {
      const rect = img.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;

      // Limita dentro de la imagen
      x = Math.max(0, Math.min(x, rect.width));
      y = Math.max(0, Math.min(y, rect.height));

      // Posiciona la lupa centrada en el cursor
      const pageX = window.scrollX + rect.left + x - LENS / 2;
      const pageY = window.scrollY + rect.top + y - LENS / 2;
      lens.style.left = `${pageX}px`;
      lens.style.top  = `${pageY}px`;

      // Desplaza el fondo para que "amplíe" donde está el cursor
      const bgX = (x / rect.width)  * (rect.width  * ZOOM) - LENS / 2;
      const bgY = (y / rect.height) * (rect.height * ZOOM) - LENS / 2;
      lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
    };

    const leave = () => {
      lens.style.display = 'none';
    };

    img.addEventListener('mouseenter', enter);
    img.addEventListener('mousemove', move);
    img.addEventListener('mouseleave', leave);
    // Por si el mouse sale del contenedor
    img.closest('div, figure')?.addEventListener('mouseleave', leave);
  });
});
